import { AlertTriangle, Clock } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  describeExpiry,
  getExpiryInfo,
  isExpiryActionable,
  type ExpiryStatus,
} from '@/lib/expiry'

interface ExpiryBadgeProps {
  /** ISO string da data de vencimento. */
  readonly date: string | null | undefined
  /** Rótulo do documento (ex.: "CNH", "CRLV", "Seguro") — vai pro title/tooltip. */
  readonly label: string
  /** Mostra texto inline além do ícone (default só ícone para densidade). */
  readonly showText?: boolean
  readonly className?: string
}

const STATUS_CLASS: Record<ExpiryStatus, string> = {
  expired: 'text-red-600',
  critical: 'text-red-600',
  warning: 'text-amber-600',
  ok: '',
  unknown: '',
}

/**
 * Ícone compacto pra ficar ao lado do nome em listas (motorista, veículo).
 * Só aparece quando há algo a sinalizar (vencido / crítico / atenção).
 * Hover mostra o motivo no tooltip nativo do browser.
 */
export function ExpiryBadge({ date, label, showText = false, className }: ExpiryBadgeProps) {
  const { status } = getExpiryInfo(date)
  if (!isExpiryActionable(status)) return null

  const delta = describeExpiry(date) ?? ''
  const Icon = status === 'warning' ? Clock : AlertTriangle
  const title = `${label}: ${delta}`

  return (
    <span
      className={cn('inline-flex items-center gap-1', STATUS_CLASS[status], className)}
      title={title}
      aria-label={title}
    >
      <Icon size={14} className="shrink-0" />
      {showText && <span className="text-xs font-medium">{label}</span>}
    </span>
  )
}
